import React, { FC } from 'react';

import { AppCol, AppFieldBox, AppRow } from 'components/appComponents';
import { Button, NumberBox } from 'devextreme-react';

type PumpPriceMinimalProps = {
  value: number;
  readOnly: boolean;
  onChange: (value: number) => void;
  clearButton: () => void;
};

const PumpPriceMinimal: FC<PumpPriceMinimalProps> = ({ value, readOnly, onChange, clearButton }) => {
  return (
    <AppFieldBox label="Минимальная цена" labelTop>
      <AppRow>
        <AppCol col={11}>
          <NumberBox
            stylingMode="underlined"
            readOnly={readOnly}
            placeholder="Минимальная цена"
            format="###0.##"
            value={value}
            onValueChange={(e) => {
              onChange(e);
            }}
          />
        </AppCol>
        <AppCol col={1}>
          <Button icon="revert" onClick={clearButton} />
        </AppCol>
      </AppRow>
    </AppFieldBox>
  );
};

export default PumpPriceMinimal;
